import Contaier from "../../components/layout/Container/Container";
import Banner from "../../components/layout/Sections/Banner";
import InnerContent from "../../components/layout/Sections/InnerContent";
import Footer from "../../components/molecules/Footer/Footer";
import Header from "../../components/molecules/Header/Header";
import { useApiService } from '../../services';
import { PageUrl, SessionKey } from '../../utils/app-config'
import { Navigate } from 'react-router-dom';
import { useEffect } from "react";
const EServices = () => {
  const { ValidateToken } = useApiService();
  const authToken = localStorage?.getItem(SessionKey.AuthToken) ?? '';
  const fetchTokenData = async () => {
    const tokenData = {
      token : authToken
    };
    
    let status = await ValidateToken(tokenData);
   
    if(status===false)
      {  
        localStorage.clear();
        return <Navigate to={PageUrl.Login} />;
      }
    };

    useEffect(() => {
      if (authToken) {  
        fetchTokenData();
      }
    },[authToken]);
  return (
    <>
      <Header></Header>
      <Contaier>
        <Banner name="E-Services" uiClass="banner-bg e-banner"></Banner>
        <InnerContent></InnerContent>
      </Contaier>
      <Footer></Footer>
    </>
  );
};

export default EServices;
